<div class="page-container" testId="quota-plan-page">
  <div class="page-shell" testId="quota-plan-shell">
    <section class="page-toolbar" testId="quota-plan-toolbar">
      <div class="page-heading">
        <div class="title-row">
          <div class="title-copy">
            <h1 class="page-title">{{ pageTitle }}</h1>
            <p class="page-subtitle">{{ pageSubtitle }}</p>
          </div>

          <div class="toolbar-actions">
            <button nz-button type="button" class="refresh-btn" (click)="reload()" [disabled]="loading" testId="quota-plan-refresh-button">
              <i nz-icon nzType="reload"></i>
              {{ t('common.refresh') }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="form-container">
      <div class="quota-plan-page">
        <section class="scope-tabs">
          <button
            *ngFor="let tab of scopeTabs; trackBy: trackByScope"
            nz-button
            type="button"
            class="scope-tab"
            [class.is-active]="tab.value === activeScope"
            (click)="switchScope(tab.value)"
            [testId]="'quota-plan-scope-tab-' + tab.value"
          >
            {{ tab.label }}
          </button>
        </section>

        <div class="quota-loading-state" *ngIf="loading" testId="quota-plan-loading" aria-busy="true">
          <article class="quota-loading-plan" *ngFor="let _ of loadingPlanPlaceholders">
            <div class="quota-loading-header">
              <div class="quota-loading-title-block">
                <div class="quota-loading-title-row">
                  <div class="quota-loading-icon"></div>
                  <div class="quota-loading-line quota-loading-line-title"></div>
                  <div class="quota-loading-chip"></div>
                </div>
                <div class="quota-loading-line quota-loading-line-subtitle"></div>
              </div>
              <div class="quota-loading-counter"></div>
            </div>

            <div class="quota-loading-overview">
              <div class="quota-loading-overview-card" *ngFor="let __ of loadingQuotaPlaceholders">
                <div class="quota-loading-line quota-loading-line-sm"></div>
                <div class="quota-loading-line quota-loading-line-value"></div>
                <div class="quota-loading-line quota-loading-line-md"></div>
              </div>
            </div>

            <div class="quota-loading-warning">
              <div class="quota-loading-line quota-loading-line-lg"></div>
              <div class="quota-loading-line quota-loading-line-md"></div>
            </div>

            <div class="quota-loading-card-grid">
              <div class="quota-loading-quota-card" *ngFor="let __ of loadingQuotaPlaceholders">
                <div class="quota-loading-line quota-loading-line-card-title"></div>
                <div class="quota-loading-line quota-loading-line-md"></div>
                <div class="quota-loading-card-metrics">
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                </div>
              </div>
            </div>
          </article>
        </div>

        <ng-container *ngIf="!loading">
          <ng-container *ngIf="normalizedPlans.length; else emptyTpl">
            <section class="group-list">
              <article
                class="group-block"
                *ngFor="let plan of normalizedPlans; let pi = index; trackBy: trackByPlanGroup"
                [class.is-collapsed]="isPlanCollapsed(plan)"
                [testId]="'quota-plan-group-' + pi"
              >
                <div class="group-header" [class.is-collapsed]="isPlanCollapsed(plan)">
                  <div class="group-main">
                    <div class="group-title-row">
                      <div class="group-title-meta">
                        <div class="group-title">{{ plan.planName || '--' }}</div>
                        <nz-tag class="status-tag" [nzColor]="getStatusColor(plan.status)">{{ getStatusLabel(plan.status) }}</nz-tag>
                      </div>
                      <div class="group-title-actions">
                        <button
                          nz-button
                          nzType="primary"
                          type="button"
                          class="header-edit-btn"
                          (click)="startEditPlanInfo(plan)"
                          [testId]="'quota-plan-edit-info-button-' + pi"
                        >
                          <i nz-icon nzType="edit"></i>
                          {{ t('quota.plan.edit-info') }}
                        </button>
                        <button
                          nz-button
                          type="button"
                          class="header-audit-btn"
                          (click)="openPlanAuditDrawer(plan, $event)"
                          [testId]="'quota-plan-audit-button-' + pi"
                        >
                          <i nz-icon nzType="history"></i>
                          {{ t('quota.toolbar.audit-log') }}
                        </button>
                      </div>
                    </div>
                    <div class="group-code">{{ plan.planDescription || t('quota.plan.no-description') }}</div>

                    <div class="collapsed-summary" *ngIf="isPlanCollapsed(plan) && plan.collapsedSummaryStats?.length">
                      <span class="collapsed-summary-label">{{ t('quota.plan.collapsed-summary') }}</span>
                      <div class="collapsed-summary-list">
                        <span class="collapsed-summary-item" *ngFor="let stat of plan.collapsedSummaryStats">
                          <strong>{{ stat.value }}</strong>
                          <em>{{ stat.title }}</em>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="group-actions">
                    <button
                      type="button"
                      class="group-summary"
                      (click)="togglePlanCollapse(plan)"
                      [attr.aria-expanded]="!isPlanCollapsed(plan)"
                      [testId]="'quota-plan-summary-button-' + pi"
                    >
                      <strong>{{ plan.items?.length || 0 }}</strong>
                      <span>{{ t('quota.plan.quota-count') }}</span>
                    </button>
                    <button
                      type="button"
                      class="collapse-trigger"
                      [class.is-collapsed]="isPlanCollapsed(plan)"
                      (click)="togglePlanCollapse(plan)"
                      [attr.aria-label]="isPlanCollapsed(plan) ? t('quota.plan.expand') : t('quota.plan.collapse')"
                      [testId]="'quota-plan-collapse-button-' + pi"
                    >
                      <i nz-icon nzType="down"></i>
                    </button>
                  </div>
                </div>

                <ng-container *ngIf="!isPlanCollapsed(plan)">
                  <div class="overview-grid" *ngIf="plan.overviewStats?.length">
                    <article class="overview-card" *ngFor="let stat of plan.overviewStats" [class]="'tone-' + stat.tone">
                      <span class="overview-title">
                        <i
                          nz-icon
                          [nzType]="getQuotaIconType(stat.key)"
                          class="quota-icon overview-icon"
                          [ngClass]="'tone-' + stat.tone"
                        ></i>
                        {{ stat.title }}
                      </span>
                      <strong class="overview-value">{{ stat.value }}</strong>
                      <span class="overview-hint">{{ stat.hint }}</span>
                    </article>
                  </div>

                  <section class="warning-panel">
                    <div class="warning-panel-header">
                      <div class="warning-panel-copy">
                        <div class="warning-panel-title-row">
                          <div class="warning-panel-title">{{ t('quota.plan.warning.title') }}</div>
                          <nz-tag class="warning-tag" nzColor="gold" *ngIf="plan.warningSummary">{{ plan.warningSummary }}</nz-tag>
                        </div>
                        <div class="warning-panel-subtitle">
                          {{ t('quota.plan.warning.subtitle') }}
                        </div>
                      </div>

                      <div class="warning-panel-actions">
                        <button
                          nz-button
                          type="button"
                          class="warning-toggle-btn"
                          (click)="toggleWarningPanel(plan)"
                          [disabled]="isEditingWarningRules(plan)"
                          [testId]="'quota-plan-warning-toggle-button-' + pi"
                        >
                          {{ isWarningPanelExpanded(plan) ? t('quota.plan.warning.collapse') : t('quota.plan.warning.expand') }}
                        </button>

                        <button
                          nz-button
                          type="button"
                          class="warning-edit-btn"
                          *ngIf="!isEditingWarningRules(plan)"
                          (click)="startEditPlanWarningRules(plan)"
                          [testId]="'quota-plan-warning-edit-button-' + pi"
                        >
                          {{ t('quota.plan.warning.edit') }}
                        </button>

                        <ng-container *ngIf="isEditingWarningRules(plan)">
                          <button
                            nz-button
                            type="button"
                            (click)="cancelEditPlanWarningRules(plan)"
                            [disabled]="isSavingWarningRules(plan)"
                            [testId]="'quota-plan-warning-cancel-button-' + pi"
                            >{{ t('common.cancel') }}</button
                          >
                          <button
                            nz-button
                            nzType="primary"
                            type="button"
                            (click)="savePlanWarningRules(plan)"
                            [disabled]="isSavingWarningRules(plan)"
                            [testId]="'quota-plan-warning-save-button-' + pi"
                          >
                            {{ isSavingWarningRules(plan) ? t('common.loading') : t('common.save') }}
                          </button>
                        </ng-container>
                      </div>
                    </div>

                    <div class="warning-panel-body" *ngIf="isWarningPanelExpanded(plan)">
                      <ng-container *ngIf="!isEditingWarningRules(plan); else warningEditorTpl">
                        <div class="warning-empty" *ngIf="!plan.warningRules?.length">{{ t('quota.plan.warning.empty') }}</div>

                        <div class="warning-rule-list" *ngIf="plan.warningRules?.length">
                          <article class="warning-rule-card" *ngFor="let rule of plan.warningRules; trackBy: trackByIndex">
                            <div class="warning-rule-head">
                              <div class="warning-rule-threshold"
                                >{{ t('quota.plan.warning.threshold') }} {{ rule.thresholdPercent ?? '--' }}%</div
                              >
                              <nz-tag class="status-tag" [nzColor]="getStatusColor(rule.status)">{{ getStatusLabel(rule.status) }}</nz-tag>
                            </div>
                            <div class="warning-rule-line" *ngIf="rule.titleTemplate"
                              >{{ t('quota.plan.warning.title-template') }}{{ rule.titleTemplate }}</div
                            >
                            <div class="warning-rule-line" *ngIf="rule.contentTemplate"
                              >{{ t('quota.plan.warning.content-template') }}{{ rule.contentTemplate }}</div
                            >
                            <div class="warning-rule-line" *ngIf="rule.lastUpdateTime"
                              >{{ t('quota.detail.updated-at') }}: {{ rule.lastUpdateTime | date: 'yyyy-MM-dd HH:mm' }}</div
                            >
                          </article>
                        </div>
                      </ng-container>

                      <ng-template #warningEditorTpl>
                        <div class="warning-empty" *ngIf="!getPlanWarningRuleDraft(plan).length">{{
                          t('quota.plan.warning.editor-empty')
                        }}</div>

                        <div class="warning-edit-list" *ngIf="getPlanWarningRuleDraft(plan).length">
                          <article
                            class="warning-edit-card"
                            *ngFor="let rule of getPlanWarningRuleDraft(plan); let index = index; trackBy: trackByIndex"
                          >
                            <div class="warning-edit-grid">
                              <div class="field-label">
                                <span>{{ t('quota.plan.warning.threshold-input') }}</span>
                                <strong class="warning-readonly-value">{{ rule.thresholdPercent ?? '--' }}%</strong>
                              </div>

                              <div class="field-label">
                                <span>{{ t('quota.table.status') }}</span>
                                <strong class="warning-readonly-value">{{ getStatusLabel(rule.status) }}</strong>
                              </div>
                            </div>

                            <div class="field-label">
                              <span>{{ t('quota.plan.warning.title-template-label') }}</span>
                              <input
                                type="text"
                                [(ngModel)]="rule.titleTemplate"
                                [placeholder]="t('quota.plan.warning.title-placeholder')"
                                [testId]="'quota-plan-warning-title-input-' + pi + '-' + index"
                              />
                            </div>

                            <div class="field-label">
                              <span>{{ t('quota.plan.warning.content-template-label') }}</span>
                              <textarea
                                rows="3"
                                [(ngModel)]="rule.contentTemplate"
                                [placeholder]="t('quota.plan.warning.content-placeholder')"
                                [testId]="'quota-plan-warning-content-textarea-' + pi + '-' + index"
                              ></textarea>
                            </div>
                          </article>
                        </div>
                      </ng-template>
                    </div>
                  </section>

                  <div class="card-grid" *ngIf="plan.items?.length; else planEmptyTpl">
                    <nz-card class="plan-card" *ngFor="let item of plan.items; trackBy: trackByPlan" (click)="openDetail(plan, item)">
                      <div class="card-header">
                        <div class="card-title-wrap">
                          <div class="plan-name">
                            <i
                              nz-icon
                              [nzType]="getQuotaIconType(item.quotaCode)"
                              class="quota-icon plan-icon"
                              [ngClass]="'tone-' + getQuotaTone(item.quotaCode)"
                            ></i>
                            {{ item.quotaName || '--' }}
                          </div>
                          <div class="plan-code">{{ item.quotaCode || '--' }}</div>
                        </div>
                        <i nz-icon nzType="right" class="enter-icon"></i>
                      </div>

                      <div class="card-metric-row">
                        <div class="metric-block">
                          <span class="metric-label">{{ t('quota.table.free-quota') }}</span>
                          <strong class="metric-value">{{ formatQuotaValue(item.freeLimitValue, item.unit) }}</strong>
                        </div>
                        <div class="metric-block">
                          <span class="metric-label">{{ t('quota.detail.default-value') }}</span>
                          <strong class="metric-value">{{ formatQuotaValue(item.defaultValue, item.unit) }}</strong>
                        </div>
                      </div>

                      <div class="card-tag-row">
                        <nz-tag class="policy-tag" [nzColor]="getChargePolicyColor(item.chargePolicyType)">
                          {{ getChargePolicyLabel(item.chargePolicyType) }}
                        </nz-tag>
                        <nz-tag class="status-tag" [nzColor]="getStatusColor(item.status)">{{ getStatusLabel(item.status) }}</nz-tag>
                      </div>

                      <div class="plan-desc">{{ item.quotaDescription || t('quota.plan.item-no-description') }}</div>
                    </nz-card>
                  </div>

                  <ng-template #planEmptyTpl>
                    <div class="group-empty">{{ t('quota.plan.empty-items') }}</div>
                  </ng-template>
                </ng-container>
              </article>
            </section>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyTpl>
  <div class="empty-wrap">
    <nz-empty [nzNotFoundContent]="t('quota.plan.empty-plans')" />
  </div>
</ng-template>

<nz-modal
  class="plan-info-modal"
  [nzVisible]="planInfoModalVisible"
  [nzFooter]="null"
  [nzWidth]="560"
  [nzClosable]="!(activePlanInfo && isSavingPlanInfo(activePlanInfo))"
  [nzMaskClosable]="!(activePlanInfo && isSavingPlanInfo(activePlanInfo))"
  (nzOnCancel)="cancelEditPlanInfo(activePlanInfo || undefined)"
  testId="quota-plan-info-modal"
>
  <ng-container *nzModalContent>
    <section class="plan-info-modal-shell" *ngIf="activePlanInfo as plan">
      <header class="plan-info-modal-header">
        <div>
          <span class="plan-info-modal-eyebrow">{{ t('quota.plan.info.eyebrow') }}</span>
          <h2>{{ t('quota.plan.info.title') }}</h2>
          <p>{{ t('quota.plan.info.subtitle') }}</p>
        </div>
        <div class="plan-info-modal-status">
          <span>{{ t('quota.plan.info.current-status') }}</span>
          <nz-tag class="status-tag modal-status-tag" [nzColor]="getStatusColor(plan.status)">{{ getStatusLabel(plan.status) }}</nz-tag>
        </div>
      </header>

      <div class="plan-info-modal-divider"></div>

      <main class="plan-info-modal-form">
        <label class="field-label">
          <span>{{ t('quota.plan.info.plan-name') }}</span>
          <input
            type="text"
            [(ngModel)]="getPlanInfoDraft(plan).planName"
            maxlength="80"
            [placeholder]="t('quota.plan.info.plan-name-placeholder')"
            testId="quota-plan-info-name-input"
          />
        </label>

        <label class="field-label plan-info-modal-description">
          <span>{{ t('quota.plan.info.plan-description') }}</span>
          <textarea
            rows="4"
            [(ngModel)]="getPlanInfoDraft(plan).planDescription"
            maxlength="300"
            [placeholder]="t('quota.plan.info.plan-description-placeholder')"
            testId="quota-plan-info-description-textarea"
          ></textarea>
        </label>
      </main>

      <div class="plan-info-modal-footer">
        <button
          nz-button
          type="button"
          class="modal-cancel-btn"
          (click)="cancelEditPlanInfo(plan)"
          [disabled]="isSavingPlanInfo(plan)"
          testId="quota-plan-info-cancel-button"
        >
          {{ t('common.cancel') }}
        </button>
        <button
          nz-button
          nzType="primary"
          type="button"
          class="modal-save-btn"
          (click)="savePlanInfo(plan)"
          [disabled]="isSavingPlanInfo(plan)"
          testId="quota-plan-info-save-button"
        >
          {{ isSavingPlanInfo(plan) ? t('common.loading') : t('quota.plan.info.save') }}
        </button>
      </div>
    </section>
  </ng-container>
</nz-modal>

<nz-drawer
  [nzVisible]="auditDrawerVisible"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  [nzWidth]="520"
  nzPlacement="right"
  nzTitle=" "
  (nzOnClose)="closeAuditDrawer()"
  testId="quota-plan-audit-drawer"
>
  <ng-container *nzDrawerContent>
    <section class="audit-drawer-shell">
      <header class="audit-drawer-header">
        <div>
          <span class="audit-drawer-eyebrow">{{ t('quota.detail.audit.record') }}</span>
          <h2>{{ auditDrawerContext?.title || t('quota.plan.audit.default-title') }}</h2>
          <p>{{ auditDrawerContext?.subtitle || t('quota.plan.audit.default-subtitle') }}</p>
        </div>
      </header>

      <nz-spin [nzSpinning]="auditDrawerLoading" testId="quota-plan-audit-spin">
        <ng-container *ngIf="auditLogs.length; else auditEmptyTpl">
          <div class="audit-log-list">
            <article
              class="audit-log-card"
              *ngFor="let log of auditLogs; let i = index; trackBy: trackByAuditLog"
              [testId]="'quota-plan-audit-log-card-' + i"
            >
              <span class="audit-log-marker" aria-hidden="true"></span>
              <div class="audit-log-head">
                <div class="audit-log-title-block">
                  <div class="audit-log-title">{{ log.fieldName || log.fieldCode || t('quota.detail.audit.field-change') }}</div>
                  <div class="audit-log-meta">
                    <span>{{ log.createTime ? (log.createTime | date: 'yyyy-MM-dd HH:mm:ss') : '--' }}</span>
                  </div>
                </div>
                <nz-tag class="status-tag" nzColor="blue">{{ log.quotaName || log.quotaCode || t('quota.detail.audit.item-tag') }}</nz-tag>
              </div>

              <div class="audit-log-diff" *ngIf="getAuditDiffRows(log) as rows">
                <div class="audit-diff-head" *ngIf="rows.length">
                  <span>{{ t('quota.detail.audit.field-change') }}</span>
                  <span>{{ t('quota.detail.audit.old-value') }}</span>
                  <span>{{ t('quota.detail.audit.new-value') }}</span>
                </div>
                <div class="audit-diff-row" *ngFor="let row of rows; trackBy: trackByAuditDiff">
                  <div class="audit-diff-field">{{ row.label }}</div>
                  <div class="audit-value-box">{{ row.oldValue }}</div>
                  <div class="audit-value-box is-new">{{ row.newValue }}</div>
                </div>
              </div>

              <div class="audit-log-foot">
                <span>{{ t('quota.detail.audit.operator') }}{{ log.operatorName || log.operatorId || '--' }}</span>
              </div>
            </article>
          </div>

          <div class="audit-pagination">
            <nz-pagination
              [nzPageIndex]="auditPageIndex + 1"
              [nzTotal]="auditTotalCount"
              [nzPageSize]="auditPageSize"
              [nzShowSizeChanger]="true"
              [nzPageSizeOptions]="[10, 20, 50]"
              [nzSimple]="true"
              (nzPageIndexChange)="onAuditPageChange($event)"
              (nzPageSizeChange)="onAuditPageSizeChange($event)"
              testId="quota-plan-audit-pagination"
            />
          </div>
        </ng-container>
      </nz-spin>
    </section>
  </ng-container>
</nz-drawer>

<ng-template #auditEmptyTpl>
  <div class="audit-empty-wrap">
    <nz-empty [nzNotFoundContent]="t('quota.detail.audit.empty')" />
  </div>
</ng-template>
